import HeroBusiness from "@/components/common/HeroBusiness";
import { useState } from "react";

type TabType = "ad-on" | "free-on" | "phone-mail";

const tabContents = {
  "ad-on": {
    title: "AD ON 서비스",
    intro:
      "E-mail 광고 또는 뉴스레터에 1회성 무료 문자메시지 전송창을 삽입하게 해주는 상품입니다. 메일의 수신자는 각메일의 문자창에서 무료문자메시지를 사용할 수 있게되어 이메일 수신률을 증가시키는 E-mail 마케팅의 부가 솔루션으로 이용 가능합니다.",
    features: [
      "이메일 오픈율을 무료 SMS 제공으로 증가시켜 사이트 방문 및 상품 판매증가 효과",
      "기존의 이메일 광고의 오픈률 추가 5%~20% 상승",
      "광고비용 대비 지불 비용이 적음",
      "메일 오픈당 지불 방식이 아닌 실사용시 지불 방식 적용",
      "고객별 HISTORY 관리를 통한 다양한 통계화면 제공",
    ],
    process: [
      { name: "광고주/기업", icon: "/img/business/icon_customer.svg" },
      { name: "Free SMS Coupon", icon: "/img/business/icon_phone.svg" },
      { name: "회원", icon: "/img/business/icon_customer.svg" },
    ],
  },
  "free-on": {
    title: "웹 메일(AMMER)",
    intro:
      "캠페인성 메일처럼 발송 시작과 끝이 존재하는 것이 아닌, 상시/개별적으로 요청되는 발송을 처리하기 위한 Mailer로서, 기존 Sendmail 시스템과 달리 하나의 메일 발송 전담 서버를 운영하여 통계 분석 및 실시간 모니터링, 메일 발송 등이 중앙 시스템에서 손쉽게 운용될 수 있는 장점이 있습니다.",
    goals: [
      "메일 발송의 긴급/실시간성 확보",
      "일반 Sendmail 시스템과 다른, 모니터링/DB 호환 등의 가능한 Tool 확보",
    ],
    features: [
      "다양한 방식으로 메일 본문 취득 가능 (URL, Static HTML, TXT file, Template file, DB query)",
      "DB를 직접 접근 할 수 없는 곳에서도 URL을 통하여 원격으로 메일 전송이 가능하며, 메일 전송에 대한 결과 (성공/실패/수신확인 등)를 Remote Notification Call의 인터페이스를 이용하여 알림이 가능",
      "보안 메일 인터페이스를 가지고 있어 보안 메일 전송이 가능",
      "중앙 집중적 관리 및 모니터링 및 통계 분석이 가능",
      "배치 발송 기능 지원",
      "메일 전송 우선 순위 설정 가능",
      "성공, 실패 및 실패 사유에 대한 내역 기록, 수신 확인 가능",
    ],
  },
  "phone-mail": {
    title: "Phone Number Mail",
    intro:
      "발신자가 핸드폰 번호를 수신 메일 주소로 지정하여 메일을 전송할수 있도록 하는 서비스입니다. E-mail 수신 알림 SMS, MMS, 전송, WAP 메일 또는 ARS(TTS) 접속 등의 확장형 부가 서비스와 접목하여 사용 가능합니다.",
    systemFeatures: [
      "폰번호 계정 정리(SMS)",
      "멀티미디어 메시지(MMS)",
      "메일 개봉 서비스(ARS)",
      "메일 서비스 정리(WAP)",
    ],
    usageList: [
      "메일 도착 알람 SMS 발송",
      "E-mail을 MMS로 변환하여 발송",
      "TTS를 이용한 메일 확인",
      "WAP Mail 확인",
    ],
  },
};

const BusinessAsp = () => {
  const [activeTab, setActiveTab] = useState<TabType>("ad-on");

  const renderAdOnContent = () => {
    const content = tabContents["ad-on"];
    return (
      <div>
        <div className="mb-10">
          <h2 className="text-[2.4rem] font-bold mb-4">{content.title}</h2>
          <p className="text-[1.6rem] text-gray-6 leading-[1.8]">{content.intro}</p>
        </div>

        <div className="mb-10">
          <h3 className="text-[1.8rem] font-semibold mb-6">서비스 프로세스</h3>
          <div className="flex flex-wrap justify-center items-center gap-6 bg-[#f8f9ff] rounded-2xl p-8">
            {content.process.map((step, idx) => (
              <div key={idx} className="flex items-center gap-6">
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto mb-3 p-4 bg-white rounded-xl shadow-sm">
                    <img src={step.icon} alt={step.name} className="w-full h-full object-contain" />
                  </div>
                  <p className="text-[1.4rem] font-medium">{step.name}</p>
                </div>
                {idx < content.process.length - 1 && (
                  <span className="material-icons-round text-[2rem] text-navy hidden md:block">
                    sync_alt
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-[1.8rem] font-semibold mb-4">서비스 특징</h3>
          <ul className="space-y-3">
            {content.features.map((feature, idx) => (
              <li key={idx} className="flex items-start gap-3 text-[1.5rem] text-gray-6">
                <span className="material-icons-round text-navy text-[1.8rem]">check</span>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  const renderFreeOnContent = () => {
    const content = tabContents["free-on"];
    return (
      <div>
        <div className="mb-10">
          <h2 className="text-[2.4rem] font-bold mb-4">{content.title}</h2>
          <p className="text-[1.6rem] text-gray-6 leading-[1.8]">{content.intro}</p>
        </div>

        <div className="mb-10">
          <h3 className="text-[1.8rem] font-semibold mb-4">서비스 목표</h3>
          <ul className="space-y-3">
            {content.goals.map((goal, idx) => (
              <li key={idx} className="flex items-start gap-3 text-[1.5rem] text-gray-6">
                <span className="material-icons-round text-navy text-[1.8rem]">flag</span>
                {goal}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-[1.8rem] font-semibold mb-4">서비스 기능</h3>
          <ul className="space-y-3">
            {content.features.map((feature, idx) => (
              <li key={idx} className="flex items-start gap-3 text-[1.5rem] text-gray-6">
                <span className="material-icons-round text-navy text-[1.8rem]">check</span>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  const renderPhoneMailContent = () => {
    const content = tabContents["phone-mail"];
    return (
      <div>
        <div className="mb-10">
          <h2 className="text-[2.4rem] font-bold mb-4">{content.title}</h2>
          <p className="text-[1.6rem] text-gray-6 leading-[1.8]">{content.intro}</p>
        </div>

        <div>
          <h3 className="text-[1.8rem] font-semibold mb-6">서비스 기능</h3>
          <div className="bg-[#f8f9ff] rounded-2xl p-8">
            <div className="flex flex-wrap justify-center items-center gap-8">
              {/* Source */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto mb-3 p-4 bg-white rounded-xl shadow-sm">
                  <img
                    src="/img/business/icon_telecom.svg"
                    alt="외부 Web Mail"
                    className="w-full h-full object-contain"
                  />
                </div>
                <p className="text-[1.4rem] font-medium">
                  외부 Web Mail /
                  <br />
                  법인 POP3 / CRM 등
                </p>
              </div>

              <div className="flex flex-col items-center">
                <span className="text-[1.3rem] text-gray-5 mb-2">
                  휴대폰번호@arreo.com
                  <br />
                  메일로 이메일 전송
                </span>
                <span className="material-icons-round text-navy text-[2rem]">east</span>
              </div>

              {/* System */}
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <p className="text-[1.5rem] font-semibold text-navy mb-4">폰넘버 메일 시스템</p>
                <ul className="space-y-2">
                  {content.systemFeatures.map((feature, idx) => (
                    <li key={idx} className="text-[1.4rem] text-gray-5">
                      • {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <span className="material-icons-round text-navy text-[2rem] hidden md:block">
                east
              </span>

              {/* Usage */}
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <ul className="space-y-2">
                  {content.usageList.map((usage, idx) => (
                    <li key={idx} className="text-[1.4rem] text-gray-6">
                      • {usage}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <HeroBusiness title="비즈니스를 완성하는" />

      <main id="main-content">
        <div className=" mx-auto px-8 lg:px-[8rem] py-[70px]">
          {/* Page Header */}
          <div className="mb-10">
            <p className="text-[1.4rem] text-gray-5 mb-2">ASP ⬥</p>
          </div>

          {/* Tabs */}
          <nav className="mb-10">
            <ul className="flex flex-wrap gap-2" role="tablist">
              {(["ad-on", "free-on", "phone-mail"] as TabType[]).map(tab => (
                <li key={tab}>
                  <button
                    role="tab"
                    aria-selected={activeTab === tab}
                    onClick={() => setActiveTab(tab)}
                    className={`px-6 py-3 rounded-full text-[1.5rem] font-medium transition-colors ${
                      activeTab === tab
                        ? "bg-navy text-white"
                        : "bg-gray-1 text-gray-6 hover:bg-gray-2"
                    }`}
                  >
                    {tab === "ad-on"
                      ? "AD ON 서비스"
                      : tab === "free-on"
                        ? "FREE ON 서비스"
                        : "Phone Number Mail"}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Tab Content */}
          <div className="bg-white rounded-3xl p-10 shadow-sm">
            {activeTab === "ad-on" && renderAdOnContent()}
            {activeTab === "free-on" && renderFreeOnContent()}
            {activeTab === "phone-mail" && renderPhoneMailContent()}
          </div>
        </div>
      </main>
    </>
  );
};

export default BusinessAsp;
